import moment from 'moment';
import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import { EARNINGS, MY_TEAM, SUPPORT_TICKETS } from '../../routes/routes';
import { TabSelectButton, Tabs } from '../../styles/GlobalComponents';
import { SectionSeparator } from '../../styles/stylesStyled';
import {
  NotificationStyled,
  Text,
  TimeDate,
  Title
} from './NotificationsStyled';
import { Notification } from '../../slices/notifications-slice';
import { P2 } from '../../styles/FontStyles';
import { colors } from '../../styles/GlobalStyles';

const Notifications = ({
  setNotificationsModal
}: {
  setNotificationsModal: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation('layout');
  const history = useHistory();
  const [tab, selectTab] = useState('referral');

  const { notifications } = useAppSelector((state) => state.notifications);

  const getCurrentDate = (notification: any) => {
    const date = moment().format('DD. MMM YYYY.');

    const notificationCreated = moment(notification?.dateCreated).format(
      'DD. MMM YYYY.'
    );

    if (date === notificationCreated) {
      return t('notifications.today');
    } else {
      return notificationCreated;
    }
  };

  const referralNotifications = notifications.filter(
    ({ type }) => type === 1 || type === 2
  );

  const earningsNotifications = notifications.filter(
    ({ type }) => type === 3 || type === 6 || type === 7
  );

  const supportNotifications = notifications.filter(({ type }) => type === 8);

  const NotificationComponent = ({
    notification,
    i
  }: {
    notification: Notification;
    i: number;
  }) => (
    <>
      <TimeDate style={{ marginBottom: 10, marginTop: 20 }}>
        {getCurrentDate(notification)}
      </TimeDate>
      <NotificationStyled
        onClick={() => {
          if (notification.type === 1 || notification.type === 2) {
            history.push(MY_TEAM);
          } else if (
            notification.type === 3 ||
            notification.type === 6 ||
            notification.type === 7
          ) {
            history.push(EARNINGS);
          } else if (notification.type === 8) {
            history.push(SUPPORT_TICKETS);
          }
          setNotificationsModal(false);
        }}>
        <div>
          <Title
            style={{ fontWeight: notification.isSeen ? 'normal' : 'bold' }}>
            {notification?.title}
          </Title>
          <Text>{notification?.content}</Text>
          <TimeDate>
            {moment(notification?.dateCreated).format('hh:mm a')}
          </TimeDate>
        </div>
      </NotificationStyled>
    </>
  );

  return (
    <div>
      <Tabs>
        <TabSelectButton
          borderColor={colors.neutral900}
          selected={tab === 'referral'}
          onClick={() => selectTab('referral')}>
          <div>{t('notifications.referal')}</div>
        </TabSelectButton>
        <TabSelectButton
          borderColor={colors.neutral900}
          selected={tab === 'earnings'}
          onClick={() => selectTab('earnings')}>
          <div>{t('notifications.earnings')}</div>
        </TabSelectButton>

        <TabSelectButton
          borderColor={colors.neutral900}
          selected={tab === 'support'}
          onClick={() => selectTab('support')}>
          <div>Support</div>
        </TabSelectButton>
      </Tabs>

      {tab === 'referral' &&
        referralNotifications.map((notification: Notification, i: number) => {
          return (
            <NotificationComponent key={i} notification={notification} i={i} />
          );
        })}

      {tab === 'referral' && !referralNotifications.length && (
        <P2 color={colors.neutral400}>
          You don't have any referral notifications.
        </P2>
      )}

      {tab === 'earnings' &&
        earningsNotifications.map((notification: Notification, i: number) => {
          return (
            <NotificationComponent key={i} notification={notification} i={i} />
          );
        })}

      {tab === 'earnings' && !earningsNotifications.length && (
        <P2 color={colors.neutral400}>
          You don't have any earnings notifications.
        </P2>
      )}

      {tab === 'support' &&
        supportNotifications.map((notification: Notification, i: number) => {
          return (
            <NotificationComponent key={i} notification={notification} i={i} />
          );
        })}

      {tab === 'support' && !supportNotifications.length && (
        <P2 color={colors.neutral400}>
          You don't have any support notifications.
        </P2>
      )}
    </div>
  );
};

export default Notifications;
